import { render, staticRenderFns } from "./order-success-unsubscribe.vue?vue&type=template&id=2bbc3eb2&scoped=true"
import script from "./order-success-unsubscribe.vue?vue&type=script&lang=ts"
export * from "./order-success-unsubscribe.vue?vue&type=script&lang=ts"
import style0 from "./order-success-unsubscribe.vue?vue&type=style&index=0&id=2bbc3eb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbc3eb2",
  null
  
)

export default component.exports